<ng-container *ngIf="_datumVan">
  <input type="text" class="input dp" appDatepickerVanTot [mindateVan]="minDatumVan" [maxdateVan]="maxDatumVan"
    [mindateTot]="minDatumTot" [maxdateTot]="maxDatumTot" [meetId]="meetId" [(ngModel)]="datums" [van]="datumInitVan"
    [tot]="datumInitTot" (onReset)="onReset($event)" />

  <p class="error-block" *ngIf="submitClicked && !validDates">{{errorMessage}}</p>
</ng-container>